import { render, staticRenderFns } from "./text-area-input.vue?vue&type=template&id=1f350af9&scoped=true"
import script from "./text-area-input.vue?vue&type=script&lang=js"
export * from "./text-area-input.vue?vue&type=script&lang=js"
import style0 from "./text-area-input.vue?vue&type=style&index=0&id=1f350af9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f350af9",
  null
  
)

export default component.exports